var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "generic-page-wrapper" }, [
    _vm.isLoading
      ? _c("div", { staticClass: "generic-page-loader spinner" }, [
          _c("div", { staticClass: "new_prelader" }),
        ])
      : _c("div", {
          staticClass: "generic-page-content ck-content",
          domProps: { innerHTML: _vm._s(_vm.pageContent) },
        }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }